<template>
    <a-modal
      :title="$t('approve-modal.title')"
      :visible="visible"
      :closable="false"
      :okText="$t('modal-btn.confirm-btn-caption')"
      :cancelText="$t('modal-btn.cancel-btn-caption')"
      :confirm-loading="isLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      
        
        <appointment-summary :appointment="item" />

        <a-form-item class="mt-20 approve-duration-form-item">	
            <a-form-item :label="$t('form-label.duration')" >
                <a-select
                    style="width: 100%;"
                    v-model="duration"
                    class="form-input"
                    show-search
                    placeholder="Select appointment type"
                    option-filter-prop="children">
                    <a-select-option value="15">
                        15 Mins
                    </a-select-option>
                    <a-select-option value="30">
                        30 Mins
                    </a-select-option>
                    <a-select-option value="45">
                        45 Mins
                    </a-select-option>
                    <a-select-option value="60">
                        60 Mins
                    </a-select-option>
                    <a-select-option value="75">
                        1 Hour 15 Mins
                    </a-select-option>
                    <a-select-option value="90">
                        1 Hour 30 Mins
                    </a-select-option>
                    <a-select-option value="105">
                        1 Hour 45 Mins
                    </a-select-option>
                    <a-select-option value="120">
                        2 Hours
                    </a-select-option>
                    <a-select-option value="135">
                        2 Hours 15 Mins
                    </a-select-option>
                    <a-select-option value="150">
                        2 Hours 30 Mins
                    </a-select-option>
                    <a-select-option value="165">
                        2 Hours 45 Mins
                    </a-select-option>
                    <a-select-option value="180">
                        3 Hours
                    </a-select-option>
                    <a-select-option value="195">
                        3 Hour 15 Mins
                    </a-select-option>
                    <a-select-option value="210">
                        3 Hour 30 Mins
                    </a-select-option>
                    <a-select-option value="225">
                        3 Hour 45 Mins
                    </a-select-option>
                    <a-select-option value="240">
                        4 Hours
                    </a-select-option>
                </a-select>
            </a-form-item>
        </a-form-item>

        <a-form-item v-show="type == 'ONLINE'" class="mb-5">	
            <!-- <a-form-item :label="$t('form-label.meeting-link')" >
                <a-input
                    style="margin-left: 5px;"
                    class="form-input"
                    :placeholder="$t('form-placeholder.meeting-link')"
                    v-model="meetingLink"
                />{{meetinglinks}}
            </a-form-item> -->

            <a-form-item 
                :label="$t('form-label.meeting-link')"
            >
                <a-select
                    :disabled="isLoading"
                    :loading="isLoading"
                    class="form-input ml-5"
                    style="width: 100%"
                    :not-found-content="isLoading ? undefined : null"
                    :placeholder="$t('form-placeholder.meeting-link')"
                    @change="onChangeMeetingLinkSelection"
                    :value="selectedMeetingLink"
                >
                    <a-spin v-if="isLoading" slot="notFoundContent" size="large" />
                    <a-select-option v-for="item in allMeetingLinks" :key="item.id" :value="item.link">
                       {{item.name}} ({{ item.link }})
                    </a-select-option>
                </a-select>
            </a-form-item>

        </a-form-item>
        
    </a-modal>
</template>
<script>

import { useAppointmentsStore } from '../../../../stores/appointments-store';
import { mapActions, mapState } from 'pinia';
import { toastMixin } from '../../../../mixins/ToastMixin';
import { appointmentsClient, meetingsClient } from '../../../../api/config.js';

import AppointmentSummary from '../../items/AppointmentSummary.vue';

export default {
    props: {
        hour: {
            type: Number,
            required: true,
        },
        min: {
            type: Number,
            required: true,
        },
        date: {
            type: String,
            required: true
        }
    },
    components: {
        AppointmentSummary
    },
    mixins: [ toastMixin ],
    data() {
        return {
            // title: 'Are You Sure You Want to Approve this appointment ?',
            isLoading: false,
            visible: false,
            duration: '15',
            allMeetingLinks: [],
            selectedMeetingLink: "",

        }
    },
    computed: {
        ...mapState(useAppointmentsStore, { 'item': 'selectedAppointment' }),
        type() {
            if (this.item && this.item.type)
                return this.item.type;
            return '';
        },
    },
    methods: {
        onChangeMeetingLinkSelection(e){
            this.meetinglink = e;
            this.selectedMeetingLink = e;
            console.log("========");
            console.log(e);
        },
        ...mapActions(useAppointmentsStore, [ 'approveSelectedAppointment' ]),
        handleOk() {
            // this.approveSelectedAppointment(this.hour, this.min, this.date, Number(this.duration));
            // this.visible = false;
            this.isLoading = true;
            let data = { id: this.item.id, hour: this.hour, min: this.min, date: this.date, durationInMins: Number(this.duration), meetingLink: this.selectedMeetingLink };
            // console.log(data);
            appointmentsClient.approveAppoinment(data).then(res => {
                if (!res.networkError) {
                    if (res.status == 202) {
                        this.approveSelectedAppointment(this.hour, this.min, this.date, Number(this.duration));
                        this.visible = false;
                        this.successToast(this.$t('toast-success-messages.appointment-approve'));    
                        this.$emit('success', this.item.id);
                        this.$emit('parentModal', false);
                    } else {
                        this.errorToast(this.$t('toast-error-messages.error') + res.status);    
                    }
                } else {
                    this.errorToast(this.$t('toast-error-messages.network-error'));    
                }
                
                this.isLoading = false;
            });
        },
        handleCancel() {
            this.visible = false;
            this.$emit('parentModal', false);
        },
        showModal() {
            this.visible = true;
        },
    },
    mounted(){
        if (this.item && this.item.official && this.item.official.id){
            // console.log(this.item.official.id);
            this.isLoading = true;
            let data = {
                id: this.item.official.id,
                page: 1,
                size: 20
            }
            meetingsClient.fetchAllOfMeetingLinks(data).then(res => {
                // console.log(res.body.list);
                if (!res.networkError && res.status == 200){
                    this.allMeetingLinks = res.body.list;
                    this.isLoading = false;
                }else{
                    this.isLoading = false;
                    console.log(res.status);
                }
            })
        }
    }
    
    
}
</script>